import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useUserMerchantAccessPermission } from 'pages/Users/hooks/useUserMerchantAccessPermission';
import { useRecordContext } from 'react-admin';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';
import { User } from 'types/embedded/user';

export type ContextMenuUserEntityPermissionsDialogButtonProps = Omit<
  ContextMenuButtonProps,
  'icon' | 'label' | 'onClick'
> & {
  onClick: (record: User) => void;
};

export const ContextMenuUserMerchantAccessButton: React.FC<
  ContextMenuUserEntityPermissionsDialogButtonProps
> = ({ onClick, ...restProps }) => {
  const record = useRecordContext<User>();
  const isUserMerchantAccessAvailable = useUserMerchantAccessPermission(record?.rolesValues);

  const { onCloseMenu } = useContextMenuContext();
  const handleClick = () => {
    record && onClick(record);
    onCloseMenu();
  };

  if (!isUserMerchantAccessAvailable) {
    return null;
  }

  return (
    <ContextMenuButton
      icon={<LockOutlinedIcon fontSize="small" />}
      label="Настроить доступ к мерчантам"
      {...restProps}
      onClick={handleClick}
    />
  );
};
